<template>
  <div class="rewards-and-certification-container">
    <div class="text-title-sm text-title-rewards">{{ $t('about.rewardAndCertification')}}</div>
    <div class="product-rewards-items">
      <div class="product-rewards-item product-camera">
        <div class="text-subtitle-xl text-subtitle-rewards">
          {{ $t('about.product.camera') }}
        </div>
        <div class="item-list-wrapper">
          <div class="item-list">
            <div
              v-for="(item, index) in cameraRewardImgList"
              class="img-wrapper"
              :key="`camera-${index}`">
              <img :src="item">
            </div>
          </div>
        </div>
      </div>
      <div class="product-rewards-item product-tableware">
        <div class="text-subtitle-xl text-subtitle-rewards">
          {{ $t('about.product.tableware') }}
        </div>
        <div class="item-list-wrapper">
          <div class="item-list">
            <div
              v-for="(item, index) in tablewareRewardImgList"
              class="img-wrapper"
              :key="`tableware-${index}`">
              <img :src="item">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'rewards-and-certification',
  data() {
    return {
      cameraRewardAllImgList: [
        '/media/img/icons/rewards_and_certification/color/camera/icon_01.png',
        '/media/img/icons/rewards_and_certification/color/camera/cnn.png',
        '/media/img/icons/rewards_and_certification/color/camera/forbes.png',
        '/media/img/icons/rewards_and_certification/color/camera/strategist.png',
        '/media/img/icons/rewards_and_certification/color/camera/very_well.png',
        '/media/img/icons/rewards_and_certification/color/camera/mother_baby_awd2021.png',
        '/media/img/icons/rewards_and_certification/color/camera/mums_aws2020.png',
        '/media/img/icons/rewards_and_certification/color/camera/mommyhood.png',
        '/media/img/icons/rewards_and_certification/color/camera/bizziebaby.png',
        '/media/img/icons/rewards_and_certification/color/camera/best_prod_2019.png',
        '/media/img/icons/rewards_and_certification/color/camera/icon_08.png',
        '/media/img/icons/rewards_and_certification/color/camera/icon_09.png',
        '/media/img/icons/rewards_and_certification/color/camera/icon_10.png',
      ],
      tablewareRewardImgList: [
        '/media/img/icons/rewards_and_certification/color/tableware/icon_01.svg',
        '/media/img/icons/rewards_and_certification/color/tableware/icon_02.svg',
        '/media/img/icons/rewards_and_certification/color/tableware/icon_03.svg',
        '/media/img/icons/rewards_and_certification/color/tableware/icon_04.svg',
        '/media/img/icons/rewards_and_certification/color/tableware/icon_05.svg',
        '/media/img/icons/rewards_and_certification/color/tableware/icon_06.svg',
        '/media/img/icons/rewards_and_certification/color/tableware/icon_07.svg',
        '/media/img/icons/rewards_and_certification/color/tableware/icon_08.svg',
        '/media/img/icons/rewards_and_certification/color/tableware/icon_09.svg',
        '/media/img/icons/rewards_and_certification/color/tableware/icon_10.svg',
      ],
    };
  },
  computed: {
    ...mapState({
      isMobile: 'isMobile',
    }),
    cameraRewardImgList() {
      if (this.isMobile) {
        return this.cameraRewardAllImgList;
      }

      return this.cameraRewardAllImgList;
    },

  },
};
</script>
<style lang="sass" scoped>
.rewards-and-certification-container
  --content-width: 1200px
  --edge-space: 0px
  --reward-img-height: 100px
  display: flex
  flex-direction: column
  align-items: center
  .text-title-rewards
    width: 90vw
    font-weight: 700
  .product-rewards-items
    display: flex
    flex-direction: column
    align-items: center
    margin: 16px 0
    .product-rewards-item
      display: flex
      flex-direction: column
      align-items: center
      margin-bottom: 48px
      &:last-child
        margin-bottom: 0px
      .text-subtitle-rewards
        margin: 12px 0
      .item-list-wrapper
        width: var(--content-width)
        display: flex
        justify-content: flex-start
        overflow-x: scroll
        .item-list
          width: 100%
          display: flex
          .img-wrapper
            margin: 20px
            &:first-child
              padding-left: var(--edge-space)
            &:last-child
              padding-right: var(--edge-space)
            img
              height: var(--reward-img-height)
              width: auto

@media screen and (min-width: 1600px)
  .rewards-and-certification-container
    --content-width: 70vw
    .product-rewards-items
      .product-rewards-item
        .text-subtitle-rewards
          margin: 20px 0

@media screen and (max-width: 1280px)
  .rewards-and-certification-container
    --content-width: 80vw

@media screen and (max-width: 576px)
  .rewards-and-certification-container
    --content-width: 90vw

@media screen and (max-width: 414px)
  .rewards-and-certification-container
    --content-width: 100vw
    --edge-space: 5vw

@media screen and (max-width: 360px)
  .rewards-and-certification-container
    --reward-img-height: 80px
    .product-rewards-items
      margin: 12px 0
      .product-rewards-item
        margin-bottom: 12px
</style>
